module.exports = __webpack_public_path__ + "img/dots_ltp5.24835ff9.png";